<template>
    <div class="hero__content mobile offer_two_months">
<!--        <div class="hero__text">-->
<!--            <div class="text">-->
<!--                <p class="pretitle">Découvrez Testachats et choisissez votre cadeau de bienvenue</p>-->
<!--                <p class="title">comme-->
<!--                    cet Airfryer-->
<!--                    multifonction</p>-->
<!--            </div>-->
<!--        </div>-->
        <video autoplay muted loop class="hero__deco" v-if="hero_is_video" :poster="home_hero_mobile_image">
            <source :src="home_hero_mobile_video" type="video/mp4">
        </video>
        <img v-else class="hero__deco" :src="home_hero_mobile_image" :alt="home_hero_alt">
        <slot></slot>
    </div>
</template>

<script>
import image_mixin from "../../_commons/fr/mixins/image_mixin";
import OfferBoxCashback from "../../_commons/fr/newComponents/OfferBoxCashback.vue";

export default {
    name: "HomeHero",
    components: {OfferBoxCashback},
    mixins: [
        image_mixin
    ]
}
</script>

<style scoped>

</style>
